/**
 * Get number value from a string value by a given decimal place.
 *
 * @param numInString number in string value
 * @param decimal number of decimal place
 */
export const getNumberFromString = (numInString: string, decimal: number) =>
  parseFloat(parseFloat(numInString).toFixed(decimal));

/**
 * Return null if number is undefined.
 *
 * Cant use "number || null" syntax because 0 is considered as false and will return unintended null.
 *
 * @param number target number
 */
export const fallbackNullNumber = (number: number | undefined) =>
  number !== undefined ? number : null;
